import { render, staticRenderFns } from "./ImagenesBaseV.vue?vue&type=template&id=32dc7536"
import script from "./ImagenesBaseV.vue?vue&type=script&lang=js"
export * from "./ImagenesBaseV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports